exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  fill: #fff;\n}\n\n.axis path,\n.axis line {\n  fill: none;\n  stroke: #ffffff;\n  shape-rendering: crispEdges;\n}\n\n.open-right, .open-left {\n  shape-rendering: crispEdges;\n}\n.grid path, .axis line {\n  stroke: #bdbdbd;\n  stroke-opacity: 1;\n}\n\n.brush .extent {\n  stroke: #ffffff;\n  stroke-opacity: 0;\n  fill-opacity: 0;\n}\n\n.tooltip {\n  pointer-events: none;\n}\n", ""]);

// exports
